<template>
    <div ref="scrollContainer" class="flex-1 px-4 py-4 border-gray-300 border-b overflow-y-scroll">
        <ul class="w-full space-y-2 max-h-0">
            <Message v-for="(message, i) in messages" :key="i" :message="message"></Message>
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Constants } from '../../constants'
import Message from './Message.vue'
import { Howl } from 'howler'
export default {
    components: {
        Message
    },
    computed: {
        ...mapGetters({
            messages: 'getMessages',
        }),
        count() {
            if(! this.messages) return 0;
            return this.messages.length;
        }   
    },
    watch: {
        count: function() {
            this.scrollToBottom();
        }
    },
    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                this.$refs.scrollContainer.scrollTop = this.$refs.scrollContainer.scrollHeight;
            });
        },
    },
    mounted() {
        ding.stop().mute(false)
        outbid.stop().mute(false)
        highest.stop().mute(false)
        congrats.stop().mute(false)
        onetime.stop().mute(false)
        twice.stop().mute(false)
        three.stop().mute(false)
        lotopen.stop().mute(false)
        lotsold.stop().mute(false)
    }
}
</script>